$(function() {

  after_load = function after_load(){
    $("img[data-vimeo-id]").each(function(index) {
      var vimeoId = $(this).data('vimeo-id');
      $.getJSON('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + vimeoId, {
        format: "json",
        width: "640"
      },
                function(data) {
        $("img[data-vimeo-id=" + vimeoId + "]").attr('src', data.thumbnail_url);
      });
    });
  }
  after_load();
  $(document).on('click', '.reset-filter', function(e){
    var get_url = window.location.origin+'/collections/{{collection.handle}}/';
    $('.collection-page .for-bg').html('<div class="_jsLoaderDiv"><img class="_jsLoader" src="https://cdn.shopify.com/s/files/1/2486/7062/t/62/assets/loader.gif?9991520270120976996" ></div>');
    $.get(get_url, function(data){
      $content =  $(data).find('.custom-filter').html();
      $('.custom-filter').html($content);
      history.pushState('', '', get_url);
      $('[data-toggle="tooltip"]').tooltip();
      after_load();
      loadafterproduct();
      //alert(get_url);
    });          
  });

  $(document).on('click', '.advanced-filter', function(e){
    e.preventDefault();
    var newIndex = $(this).attr('data-group');
    var newValue = $(this).attr('data-handle');
    get_load_data(newIndex , newValue);
  });

  $(document).on('change', '.advanced-filters', function(e){
    e.preventDefault();
    var newIndex = $(this).find(":selected").attr('data-group');
    var newValue = $(this).find(":selected").attr('data-handle');
    get_load_data(newIndex , newValue);
    loadafterproduct();
  });    

  function get_load_data(newIndex , newValue){
    var base_url = window.location.origin+'/collections/{{collection.handle}}/';
    var dataGroup = {};
    var slug  = '';
    $('.advanced-filter').each(function (){
      var data_group = $(this).attr('data-group');
      dataGroup[data_group]  = '';          
    });
    $.each(dataGroup, function (index, value) {
      dataGroup[index] = $('.active-filter[data-group="'+index+'"]').data('handle');
      if((index == newIndex)){
        dataGroup[index] = (dataGroup[index] == newValue)?'':newValue;
      }
      if(dataGroup[index]){
        if(slug) slug +='+';
        slug +=dataGroup[index];//'+'dataGroup[index];
      }           
    });
    var get_url = base_url+slug;
    $('.collection-page .for-bg').html('<div class="_jsLoaderDiv"><img class="_jsLoader" src="https://cdn.shopify.com/s/files/1/0277/1025/9297/t/1/assets/ajax-loader.gif?v=1575285359" ></div>');
    $.get(get_url, function(data){
      $content =  $(data).find('.custom-filter').html();
      $('.custom-filter').html($content);
      loadafterproduct();
      history.pushState('', '', get_url);
      $('[data-toggle="tooltip"]').tooltip();
      after_load();
    });
  }          
});




///////////////////  Nutrition Model Pop up /////////////////
$(".pro_title").on("click", function() {
  var modal = $(this).data("modal");
  $(modal).show();
});

$(".modal").on("click", function(e) {
  var className = e.target.className;
  if(className === "modal" || className === "close"){
    $(this).closest(".modal").hide();
  }
});

var jwConfig = {
  file: 'https://content.jwplatform.com/videos/bB9rv5sH-mks7yWzt.mp4',
  width: 640,
  height: 320,
  autostart: false,
  mute: false,
  events: {
    onTime: function(e){                 
      if(!e.viewable){
        this.pause();
      }
    }
  },
  cast: {} 
}; 
jwplayer("custome-player-jw155").setup(jwConfig);



$(document).on('click', '.fgh' , function(){
  $(".video-click").hide();
  $("html, body").animate({ scrollTop: $('.vedio-box').offset().top - 100 }, 500);
  var iframe = $(this).attr('data-src');
  var jwConfig = {
    file: iframe,
    width: 640,
    height: 320,
    autostart: true,
    mute: false,
    events: {
      onTime: function(e){                 
        if(!e.viewable){
          this.pause();
        }
      }
    },
    cast: {} 
  }; 
  jwplayer("custome-player-jw3").setup(jwConfig);
  console.log(iframe);
});

$(document).on('click', '.playicons' , function(){
  $(".video-click").hide();
  var iframe = $(this).attr('data-src');
  var jwConfig = {
    file: iframe,
    width: 1024,
    height: 400,
    autostart: true,
    mute: false,
    events: {
      onTime: function(e){                 
        if(!e.viewable){
          this.pause();
        }
      }
    },
    cast: {} 
  }; 
  jwplayer("custome-player-jw1").setup(jwConfig);
  console.log(iframe);
});

$(document).on('click', '.onlickply' , function(){
//   $(".caption-content").hide();
//   $(".home-vedio").hide();
  var iframe = $(this).attr('data-src');
  var jwConfig = {
    file: iframe,
    width: 1024,
    height: 400,
    autostart: true,
    mute: false,
    events: {
      onTime: function(e){                 
        if(!e.viewable){
          this.pause();
        }
      }
    },
    cast: {} 
  }; 
  jwplayer("custome-player-jw11").setup(jwConfig);
  console.log(iframe);
});

$('#playvideoicon').click(function() {
  var iframe = $('#playvideo')[0];
  var player = $f(iframe);
  player.api('play');
  $("#playvideoicon").hide();
  $("#playvideoimg").hide();
});
$('#playvideoicon-1').click(function() {
  var iframe = $('#playvideo-1')[0];
  var player = $f(iframe);
  player.api('play');
  $("#playvideoicon-1").hide();
  $("#playvideoimg-1").hide();
});
$('#playvideoicon-2').click(function() {
  var iframe = $('#playvideo-2')[0];
  var player = $f(iframe);
  player.api('play');
  $("#playvideoicon-2").hide();
  $("#playvideoimg-2").hide();
});


///nav toggle ////
$(".nav-toggle").click(function(){
  $("body").toggleClass("m-open");
});
///nav toggle ////


///////////// Slick Slider //////////////////
$(".topRead-slider").slick({
  slidesToShow: 1,
  arrows:true,
  dots:true,
  speed: 500
});

$(".slider-annus").slick({
  slidesToShow: 1,
   slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:2000,
  arrows:false,
  dots:false
});

$(".testi-slider").slick({
  slidesToShow: 1,
  arrows:true,
  dots:true,
  speed: 500
});

$('.pln-hhh').slick({
  dots: false,
  infinite: true,
  centerMode: true,
  centerPadding: '160px',
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        centerMode: true,
        centerPadding: '120px',
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        centerMode: true,
        centerPadding: '150px',
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        centerPadding: '120px',
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        infinite: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});



$('.pro-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.pro-slidernew').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.home_how_works').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.slider-home-payment').slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        centerMode: true,
        centerPadding: '30px',
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


var newWindowWidth = $(window).width();
if (newWindowWidth < 767 ) {

  $('.programme-nutrition1').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });

  $('.bonusshared').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

}
$('.programme-motivation').slick({
  dots: false,
  arrows: true,
  slidesToScroll: 4,
  nextArrow: $('.swip_text'),
  draggable:true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        draggable:true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        draggable:true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        dots: true
      }
    }
  ]
});
$('.newplanslider-1').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
$('.newplanslider-2').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});


$('.proslider').slick({
  infinite: true,
  arrows: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.proslider-2').slick({
  infinite: true,
  arrows: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.proslider-3').slick({
  infinite: true,
  arrows: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.proslider-4').slick({
  infinite: true,
  arrows: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.programme-blog').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.home_transformations').slick({
  dots: true,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        dots: true
      }
    }
  ]
});

$('.home_Testimonials').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 4,
  nextArrow: $('.btn-button2'),
  draggable:true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: true,
        draggable:true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        draggable:true,
        slidesToScroll: 2,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        draggable:true,
        slidesToScroll: 2,
        dots: false
      }
    }
  ]
});


$('.step_slider').slick({
  dots: true,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.step_slidernew').slick({
  dots: true,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});



////////////////// Recipe filter for page ///////////////

$(function() {
  $(document).on('click', '.reset-filter', function(e){
    var get_url = window.location.origin+'/pages/programme-page';
    $('.collection-page .for-bg').html('<div class="_jsLoaderDiv"><img class="_jsLoader" src="https://cdn.shopify.com/s/files/1/0277/1025/9297/files/1_ajax-loader.gif?v=1577522820" >  </div>');
    $.get(get_url, function(data){
      $content =  $(data).find('#mylist').html();
      $('#mylist').html($content);
      history.pushState('', '', get_url);
    });          
  });

  $(document).on('click', '.advanced-filter', function(e){
    e.preventDefault();
    var newIndex = $(this).attr('data-group');
    var newValue = $(this).attr('data-handle');
    get_load_data(newIndex , newValue);
  });

  $(document).on('change', '.advanced-filters', function(e){
    e.preventDefault();
    //      $('.jsActive').removeClass('active');
    //       $(this).addClass('active');
    var newIndex = $(this).find(":selected").attr('data-group');
    var newValue = $(this).find(":selected").attr('data-handle');
    get_load_data(newIndex , newValue);

  });    

  function get_load_data(newIndex , newValue){
    var base_url = window.location.origin+'/collections/nutrition/';
    var dataGroup = {};
    var slug  = '';
    $('.advanced-filter').each(function (){
      var data_group = $(this).attr('data-group');
      dataGroup[data_group]  = '';          
    });
    $.each(dataGroup, function (index, value) {
      dataGroup[index] = $('.active-filter[data-group="'+index+'"]').data('handle');
      if((index == newIndex)){
        dataGroup[index] = (dataGroup[index] == newValue)?'':newValue;
      }
      if(dataGroup[index]){
        if(slug) slug +='+';
        slug +=dataGroup[index];//'+'dataGroup[index];
      }           
    });
    var get_url = base_url+slug;
    $('.collection-page .for-bg').html('<div class="_jsLoaderDiv"><img class="_jsLoader" src="https://cdn.shopify.com/s/files/1/0277/1025/9297/files/1_ajax-loader.gif?v=1577522820" ></div>');
    $.get(get_url, function(data){
      $content =  $(data).find('#mylist').html();

      $('#mylist').html($content);
      console.log('aftrfilter');
      history.pushState('', '', window.location.origin+'/pages/programme-page');

      $('[data-toggle="tooltip"]').tooltip();
      $(".pro_title").on("click", function() {
        var modal = $(this).data("modal");
        $(modal).show();
      });

      $(".modal").on("click", function(e) {
        var className = e.target.className;
        if(className === "modal" || className === "close"){
          $(this).closest(".modal").hide();
        }
      });
    });

  }          
});


///////////// product-workout-complete //////////////////


function goBack() {
  window.history.go(-1);
}



// $(".scroll").click(function() {
//      $('html, body').animate({
//          scrollTop: $("#get_scroll").offset().top
//      }, 1500);
//  });





//////////////// sticky header header


$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 1) {
    $(".site-header").addClass("darkHeader");
  } else {
    $(".site-header").removeClass("darkHeader");
  }
});




$(".nav_toggle").click(function(){
  $("body").toggleClass("m_open");
});




$('.f-blogs').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
    
  ]
});